import { useState } from 'react';
import { supabase } from '../lib/supabase';

// Email/password, same as native. Supabase email confirmation is off per
// STATUS.md, so sign-up -> signed-in session lands in one round trip.
export function SignInScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mode, setMode] = useState<'in' | 'up'>('in');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === 'in') {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      } else {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
      }
    } catch (e: any) {
      setError(e?.message ?? String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <h1>Cupwire</h1>
      <p className="tagline">Voice + location for your crew.</p>

      <form onSubmit={submit} className="auth-form">
        <input
          type="email"
          autoComplete="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          autoComplete={mode === 'in' ? 'current-password' : 'new-password'}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={6}
        />
        {error && <p className="auth-error">{error}</p>}
        <button type="submit" disabled={busy} className="auth-submit">
          {busy ? '…' : mode === 'in' ? 'Sign in' : 'Create account'}
        </button>
        <button
          type="button"
          onClick={() => setMode(mode === 'in' ? 'up' : 'in')}
          className="auth-switch"
        >
          {mode === 'in' ? 'Need an account? Sign up' : 'Have an account? Sign in'}
        </button>
      </form>

      <style>{`
        .auth-wrap {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 32px 24px;
          gap: 8px;
        }
        .auth-wrap h1 {
          font-size: 36px;
          font-weight: 800;
          margin: 0;
          color: var(--accent);
          letter-spacing: -0.5px;
        }
        .tagline {
          color: var(--text-muted);
          font-size: 14px;
          margin: 0 0 24px;
        }
        .auth-form {
          display: flex;
          flex-direction: column;
          gap: 12px;
          width: 100%;
          max-width: 340px;
        }
        .auth-form input {
          background: var(--surface);
          color: var(--text);
          border: 1px solid var(--divider);
          border-radius: 10px;
          padding: 14px;
          font-size: 16px;
        }
        .auth-form input:focus {
          outline: none;
          border-color: var(--accent);
        }
        .auth-error {
          color: var(--error);
          font-size: 13px;
          margin: 0;
        }
        .auth-submit {
          background: var(--accent);
          color: var(--bg);
          border: none;
          border-radius: 10px;
          padding: 14px;
          font-size: 16px;
          font-weight: 700;
        }
        .auth-submit:disabled { opacity: 0.5; }
        .auth-switch {
          background: transparent;
          color: var(--accent);
          border: none;
          padding: 8px;
          font-size: 13px;
        }
      `}</style>
    </div>
  );
}
